import _afterInit from './_afterinit.js';
import addDataKeys from './adddatakeys.js';
import removeDataKeys from './removedatakeys.js';
import isDataKey from './isdatakey.js';
import setData from './setdata.js';
import keyOf from './keyof.js';
import keys from './keys.js';
import values from './values.js';
import entries from './entries.js';
import toJSON from './tojson.js';
import each from './each.js';
import iterator from './iterator.js';
import addSymbolMembers from '../_helpers/addsymbolmembers.js';
// the members Class() puts on the prototype; extends and constructor join in ./index.js
var instanceMembers = {
  _afterInit: _afterInit,
  setData: setData,
  addDataKeys: addDataKeys,
  removeDataKeys: removeDataKeys,
  isDataKey: isDataKey,
  keys: keys,
  values: values,
  entries: entries,
  keyOf: keyOf,
  toJSON: toJSON,
  each: each,
  isMatreshkaObject: true,
  jset: setData // alias
};
addSymbolMembers(instanceMembers, iterator);
export default instanceMembers;